module.exports = __webpack_public_path__ + "img/users-01.7deb0420.svg";